import ClipboardJS from 'clipboard'

up.compiler('.copy-to-clipboard-button', function(button) {
  new ClipboardJS(button)
})
